window.addEventListener('load', event => {
    const bookingContentBlocks = document.querySelectorAll('.booking-content-block, .booking-content-panel');
    const bookingform = document.querySelector('form.booking-form');

    // Runs before ajax submit
    bookingform?.addEventListener('freeform-ajax-before-submit', function(event) {
        const checkboxes = document.querySelectorAll('label[for="form-input-selectSessions"] + div input[type="checkbox"]:checked');

        const values = [...checkboxes].map((checkbox) => {
            const label = checkbox.parentElement;

            return label.innerText.replace('Join the waitlist (This session is fully booked)', '(Joined Waitlist)');
        });

        event.data.set('selectedSessions', values.join("\n"));
    });

    bookingContentBlocks.forEach(function(block) {
        const checkboxes = block.querySelectorAll('input[type="checkbox"][data-related-checkbox]');
        let userHasTriggeredScroll = false;

        checkboxes.forEach(function(checkbox) {
            checkbox.addEventListener('change', function() {
                // Get the value of data-related-checkbox attribute
                const relatedCheckbox = checkbox.getAttribute('data-related-checkbox');

                // Select all buttons within the block with matching data-related-checkbox attribute
                const buttons = block.querySelectorAll('button[data-related-checkbox="' + relatedCheckbox + '"]');

                // Update data-active attribute of buttons based on checkbox state
                buttons.forEach(function(button) {
                    button.setAttribute('data-active', checkbox.checked.toString()); // Convert boolean to string
                });
            });
        });

        block.addEventListener('click', function(event) {
            const form = block.querySelector('form');

            // Check if the click target is a button with the data-related-checkbox attribute
            if (event.target.matches('button[data-related-checkbox]')) {
                // Get the value of data-related-checkbox attribute from the clicked button
                const relatedCheckboxValue = event.target.getAttribute('data-related-checkbox');

                // Find the checkbox with matching data-related-checkbox attribute
                const relatedCheckboxInput = block.querySelector('input[type="checkbox"][data-related-checkbox="' + relatedCheckboxValue + '"]');

                // If checkbox found, update checkbox state based on button click
                if (relatedCheckboxInput) {
                    relatedCheckboxInput.checked = !relatedCheckboxInput.checked;

                    relatedCheckboxInput.dispatchEvent(new Event('change'));
                }

                // Check if form exists and screen width is greater than or equal to 768px and button pressed is currently active
                if (form && window.matchMedia('(min-width: 768px)').matches && event.target.matches('button[data-active="true"]') && !userHasTriggeredScroll) {
                    // Scroll to the form element
                    form.scrollIntoView({ behavior: 'smooth' });

                    userHasTriggeredScroll = true;
                }
            }
        });
    });
});
